

import { hitTest, normalizeEvent } from '@/extensions/libs/hitTest';


/**
 * # Vue.prototype.hitTest()
 * 
 * Registers a global mixin `hitTest( event )` for all Vue components.
 * Returns `true` if `this.$el` was underneath the mouse during an touch-
 * or click-event.
 * 
 * Use inside a component method like this:
 * 
 * ```
 * // Check for hitTest with this.$el:
 * if (this.hitTest( event )) {...}
 * 
 * // Check for hitTest with this.$refs.something
 * if (this.hitTest( event, this.$refs.something )) {...}
 * ```
 * 
 * By registering events on the `window` level we can fix common problems:
 * Useful, if there are conflicting eventListeners that stopPropagation of
 * the event (i.e. a slider that won't bubble click / touch events).
 * Example:
 * 
 * ```
 * // Register an eventListener.
 * mounted() {
 * 	window.addEventListener('mousedown', this.onStartMove);
 * },
 * 
 * // Please NEVER forget this!
 * beforeDestroy() {
 * 	window.removeEventListener('mousedown', this.onStartMove);
 * },
 * 
 * methods: {
 * 	// Only react to events on this element!
 * 	onStartMove( event ) {
 * 		if (!this.hitTest( event )) return false;
 * 	}
 * }
 * ```
 * @class extensions_plugins_hitTest
 */
export default {
	install (Vue, options) {

		Vue.prototype.hitTest = function ( event, $el = false ) {
			return hitTest( event, $el || this.$el );
		}

		Vue.prototype.normalizeEvent = function ( event ) {
			return normalizeEvent( event );
		}

	}
}